import {
  Sparkles, Armchair, Droplets, Wand2, Brush, ShieldCheck,
  Lightbulb, CircleDot, Layers, Component, Wind, Cog, Car,
  Award, Gem, Heart, Package, Headset, ThumbsUp, Clock, Star,
} from "lucide-react";

const map = {
  Sparkles, Armchair, Droplets, Wand2, Brush, ShieldCheck,
  Lightbulb, CircleDot, Layers, Component, Wind, Cog,
  Award, Gem, Heart, Package, Headset, ThumbsUp, Clock, Star,
};

export const ServiceIcon = ({ name, className }) => {
  const Icon = map[name] || Car;
  return <Icon className={className} />;
};
